import NewSubmittalDetailsPage from "./new-submittal-details/submittal-details";

function SubmittalDetailspage() {
  return <NewSubmittalDetailsPage />;
}

export default SubmittalDetailspage;
